import React, { useContext, useEffect, useState } from "react";
import {
  Paper,
  makeStyles,
  Box,
  alpha,
  InputBase,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Backdrop,
  CircularProgress,
  IconButton,
  Button,
  Checkbox,
  Toolbar,
  Typography,
  Tooltip,
  TableContainer,
  TextField,
  InputAdornment,
  useTheme,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { Pagination } from "@material-ui/lab";
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import apiConfigs from "../../config/config";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteTimesheet,
  getTimesheet,
} from "../../store/action/timesheet/timesheetAction";
import EnhancedTableHead from "./EnhancedTableHead";
import { headCells } from "./Headcells";
import AlertDialog from "../../components/Alert/AlertDialog";
import axios from "axios";
import Notification from "../../components/Notification/Notification";
import Config from "../../config/config";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import {
  notificationFail,
  notificationSuccess,
} from "../../store/action/notificationMsg";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { GetApp, Visibility } from "@material-ui/icons";
import Loading from "../../components/Loading/Loading";
import EnhancedTableToolbar from "../../components/EnhancedTableToolbar";
import TablePaginationControls from "../../components/TablePaginationControls";
import moment from "moment/moment";
import { ThemeContext } from "../../App";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    // overflowX: "auto",
    padding: 20,
    background: theme.palette.background.main
  },

  container: {
    marginTop: "15px",
    maxHeight: "calc(100vh - 335px)",
  },
  actionButtons: {
    display: "flex",
    gap: theme.spacing(1),
    flexWrap: "wrap",
  },
}));

const Timesheet = ({ match }) => {
  const { mode } = useContext(ThemeContext)
  const theme = useTheme();
  const classes = useStyle();
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(1);
  const [perPage, setPerPage] = useState(15);
  const [searchData, setSearchData] = useState({ search: "", id: "" });
  const history = useHistory();
  const { getTimesheetItem, loading } = useSelector((state) => state.timesheet);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("timesheet_name");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [Id, setId] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const baseUrl = apiConfigs.API_URL + "uploads/temp_timesheet/";
  const [loadings, setLoadings] = useState(false);
  const [timesheetMsgError, setTimesheetError] = useState("");
  const loginUserInfo = JSON.parse(
    window.localStorage.getItem("loginUserInfo")
  );
  const [selected, setSelected] = useState([]);
  const [multipleDelete, setMultipleDelete] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState(
    headCells[0].map((col) => col.id) // initially all columns visible
  );

  const handleColumnToggle = (columnId) => {
    setVisibleColumns((prev) =>
      prev.includes(columnId)
        ? prev.filter((id) => id !== columnId)
        : [...prev, columnId]
    );
  };

  const getTimesheetList = (
    pageNo = 1,
    perPage = 15,
    search = "",
    type = order,
    column_name = orderBy
  ) => {
    dispatch(getTimesheet({ pageNo, perPage, search, type, column_name }));
  };

  const handleChangePage = (event, value) => {
    setPage(value);
    setTimeout(getTimesheetList(value, perPage), 2000);
  };

  const handlePerPageChange = (event) => {
    const newPerPage = event.target.value;
    setPerPage(newPerPage);
    setPage(page); // Reset to first page when changing items per page
    getTimesheetList(page, newPerPage, searchData.search);
  };

  const handleSearchChange = (event) => {
    const d1 = event.target.value;
    if (d1) {
      setTimeout(getTimesheetList(page, perPage, d1), 100);
    } else {
      setTimeout(getTimesheetList(page, perPage, ""), 100);
    }
    setSearchData({ ...searchData, [event.target.name]: event.target.value });
  };

  const handleClickSearch = (event, value) => {
    setTimeout(getTimesheetList(page, perPage, searchData.search), 1000);
  };

  const handleRequestSort = (
    property,
    setOrder,
    setOrderBy,
    orderBy,
    order
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const deleteTimesheetById = (timesheet_id) => {
    setDisabled(true);
    setId(timesheet_id);
    setDeleteOpen(true);
  };
  const deleteTimesheetClose = () => {
    setDeleteOpen(false);
  };
  const alertResponse = (id) => {
    if (disabled === true) {
      dispatch(deleteTimesheet(id));
    }
    setDisabled(false);
    getTimesheetList();
  };

  const handleUploadTimeSheet = (e) => {
    setLoadings(true);

    const pic = e.target.files;
    let formData = new FormData();
    for (const file of pic) {
      formData.append("timesheets[]", file, file.name);
    }

    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    axios
      .post(
        `${apiConfigs.API_URL}api/organization/upload-multiple-timesheet`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${loggedInUser}`,
          },
        }
      )
      .then((response) => {
        const dataItem = response.data;
        if (dataItem && dataItem.status === true) {
          setTimesheetError(dataItem);
          setLoadings(false);
          getTimesheetList();
        } else {
          setTimesheetError(dataItem);
          setLoadings(false);
        }
      })
      .catch((error) => {
        setTimesheetError("Sorry timesheet upload failed");
        setLoadings(false);
      });
  };

  useEffect(() => {
    if (
      (loginUserInfo?.role === "STAFF" &&
        (loginUserInfo?.is_smt === "Yes")) ||
      loginUserInfo?.role === "ORGANIZATION" ||
      loginUserInfo?.role === "SUPERADMIN"
    ) {
      getTimesheetList();
    }
  }, [orderBy, order]);

  const downloadFile = async (name) => {
    try {
      const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
      const response = await axios.get(
        `${Config.API_URL}api/organization/download-pdf/${name}`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${loggedInUser}`,
          },
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Create a link element to trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name);

      // Append the link to the document and trigger the download
      document.body.appendChild(link);
      link.click();
      getTimesheetList()
    } catch (error) {
      console.error("Error downloading the file:", error);
      // Handle error as needed
    }
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;
  const toolbarStyles = (theme) => ({
    root: {
      paddingRight: theme.spacing.unit,
    },
    highlight:
      theme.palette.type === "light"
        ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
        : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
    spacer: {
      flex: "1 1 100%",
    },
    actions: {
      color: theme.palette.text.secondary,
    },
    title: {
      flex: "0 0 auto",
    },
  });

  // const EnhancedTableToolbar = (props) => {
  //   const { numSelected, classes } = props;
  //   setMultipleDelete(numSelected > 0);
  //   return <></>;
  // };

  // const EnhancedTableToolbarWithStyles =
  //   withStyles(toolbarStyles)(EnhancedTableToolbar);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds =
        getTimesheetItem?.data?.data &&
        getTimesheetItem?.data?.data.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const deleteSelected = async (ids) => {
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    await axios
      .post(
        `${apiConfigs.API_URL}api/organization/delete-mutiple-temp-timesheet`,
        { ids: ids },
        {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${loggedInUser}`,
          },
        }
      )
      .then((response) => {
        const data = response.data;

        if (data?.status === true) {
          dispatch(notificationSuccess(data?.message));
          getTimesheetList();
          setSelected([]);
        } else {
          dispatch(notificationFail(data?.message));
        }
      })
      .catch((error) => {
        console.log("errro", error);
        dispatch(notificationFail(error));
      });
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };
  const navigate = (url) => {
    history.push(url);
  };

  useEffect(() => {
    document.documentElement.style.setProperty('--bg-color', theme.palette.grey[1000]);
    document.documentElement.style.setProperty('--sticky-header', theme.palette.thead);
    document.documentElement.style.setProperty('--sticky-odd', theme.palette.background.stickyOdd);
    document.documentElement.style.setProperty('--sticky-even', theme.palette.background.stickyEven);

  }, [mode]);

  return (
    <>
      {loading && <Loading open={loading} />}

      {timesheetMsgError && timesheetMsgError?.message && (
        <Notification
          data={timesheetMsgError?.message}
          status={timesheetMsgError?.status === true ? "success" : "error"}
        />
      )}
      {(loginUserInfo?.role === "STAFF" &&
        (loginUserInfo?.is_smt === "Yes")) ||
        loginUserInfo?.role === "ORGANIZATION" ||
        loginUserInfo?.role === "SUPERADMIN" ? (
        <>
          <Paper className={`${classes.root} mb-6`}>
            <Box mb={3} display="flex" alignItems="center" justifyContent="space-between">
              <TextField
                size="small"
                placeholder="Search now..."
                name="search"
                onChange={handleSearchChange}
                variant="outlined"
                onKeyPress={(e) => e.key === "Enter" && handleClickSearch()}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon style={{ cursor: "pointer" }} onClick={handleClickSearch} />
                    </InputAdornment>
                  ),
                }}
                className="modernSearchField"
              />

              <Box className={classes.actionButtons}>
                {selected.length > 0 &&
                  ((loginUserInfo?.role === "STAFF" &&
                    loginUserInfo?.permissions?.some((p) => p.toLowerCase() === "timesheet-delete")) ||
                    loginUserInfo?.role !== "STAFF") && (
                    <Button variant="contained" color="secondary" onClick={() => deleteSelected(selected)}>
                      Delete Selected
                    </Button>
                  )}

                <Button variant="contained" color="primary" component="label">
                  Upload Timesheets
                  <input type="file" name="timesheet" hidden multiple accept="image/*,.pdf" onChange={handleUploadTimeSheet} />
                </Button>

                <EnhancedTableToolbar
                  numSelected={0}
                  visibleColumns={visibleColumns}
                  handleColumnToggle={handleColumnToggle}
                  headCells={headCells[0]}
                />
              </Box>
            </Box>

            <TableContainer className={classes.container}>
              <Table stickyHeader>
                {/* <EnhancedTableToolbarWithStyles numSelected={selected.length} /> */}
                <EnhancedTableHead
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={(event, property) => {
                    handleRequestSort(
                      property,
                      setOrder,
                      setOrderBy,
                      orderBy,
                      order
                    );
                  }}
                  rowCount={getTimesheetItem?.data?.data?.length}
                  headCells={headCells[0]}
                  numSelected={selected.length}
                  onSelectAllClick={handleSelectAllClick}
                  visibleColumns={visibleColumns}
                />
                <TableBody>
                  {getTimesheetItem?.data?.data &&
                    getTimesheetItem?.data?.data.map((list, index) => {
                      const isItemSelected = isSelected(list.id);
                      return (
                        <TableRow
                          hover
                          onClick={(event) => handleClick(event, list.id)}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={list.id}
                          selected={isItemSelected}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox checked={isItemSelected} style={{ color: theme.palette.listItem }} />
                          </TableCell>
                          {visibleColumns.includes("id") && <TableCell style={{ color: theme.palette.listItem }}>{getTimesheetItem?.data?.from + index}</TableCell>}
                          {visibleColumns.includes("timesheet_name") && <TableCell style={{ color: theme.palette.listItem }}>{list.timesheet_name}</TableCell>}
                          {visibleColumns.includes("timesheet_name") && <TableCell style={{ color: theme.palette.listItem }}>{list.organization_name}</TableCell>}
                          {visibleColumns.includes("timesheet_name") && <TableCell style={{ color: theme.palette.listItem }}>{moment(list.created_at).format("DD-MMM-YYYY")}</TableCell>}

                          {visibleColumns.includes("action") &&
                            <TableCell align="center" >
                              <Box display="flex" gap={4} justifyContent="center">
                                <Tooltip title="View">
                                  <IconButton size="small" color="primary" style={{ marginRight: "15px" }} component="a" href={`${baseUrl}${list.timesheet_name}`} target="_blank" onClick={(e) => e.stopPropagation()}>
                                    <Visibility />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Download">
                                  <IconButton size="small" color="theme.gray" style={{ marginRight: "15px" }} onClick={(e) => { e.stopPropagation(); downloadFile(list.timesheet_name); }}>
                                    <GetApp />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Delete">
                                  <IconButton size="small" color="secondary" style={{ marginRight: "15px" }} onClick={(e) => { e.stopPropagation(); deleteTimesheetById(list.id); }}>
                                    <DeleteIcon />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </TableCell>
                          }
                        </TableRow>
                      );
                    })}
                  {!getTimesheetItem?.data?.data && (
                    <TableRow>
                      <TableCell scope="row" colSpan="6" align="center">
                        Sorry,timesheet not available!
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePaginationControls
              page={page}
              rowsPerPage={perPage}
              totalRecords={getTimesheetItem?.data?.total}
              onPageChange={handleChangePage}
              handlePerPageChange={handlePerPageChange}
            />

            <AlertDialog
              id={Id}
              response={alertResponse}
              open={deleteOpen}
              close={deleteTimesheetClose}
              title="Delete Timesheet"
              description="Are you sure you want to delete timesheet?"
              buttonName="Delete"
            />
          </Paper>
        </>
      ) : (
        <div className="" align="center">
          <b>Sorry,You have no access!</b>
        </div>
      )
      }
    </>
  );
};

export default Timesheet;
